import {Label, PickInit} from "back/commons/basis";
import {IItemUiEnv} from "back/wsp/views/itemMain";
import {IReg, REG} from "lib/commons/registry";
import {DOM, JSX} from "lib/commons/xml/dom";
import {EItStatus} from "lib/wsp/item";
import {JItemInfo, JItemSsError, WSP} from "lib/wsp/wsp";
import {SRC} from "lib/wsp/src";

/**
 * View affichant les erreurs et alertes issues des feuilles de stockage des items.
 *
 * Config attributes:
 */
export interface ItemMsgSs extends Label {
	initialize(init: OItemMsgSsInit): this;
}

export interface OItemMsgSsInit extends PickInit<ItemMsgSs, 'errors'> {
	reg?: IReg<IItemUiEnv>
}

export class ItemMsgSs extends Label {
	reg: IReg<IItemUiEnv>;

	protected _details: string;

	/** Si définit, restrinet la liste des pbs affichés.*/
	errors: { code: RegExp }[];

	get details(): string {return this._details}

	set details(val: string) {
		if (this._details != val) {
			this._details = val;
			this.refresh();
		}
	}

	_initialize(init: OItemMsgSsInit) {
		this.reg = this.findReg(init);
		super._initialize(init);
		this.reg.installSkin("scroll/small", this.shadowRoot);
		this.errors = init.errors;
		this.reg.env.longDescChange.add(() => this.onUpdate());
		this.onUpdate();
	}

	async onUpdate() {
		const longDesc = this.reg.env.longDesc;
		this._label = "";
		this._details = "";
		if (longDesc.itSt !== EItStatus.ok) {
			// this._label = "..."; //non crée un flash graphique.
			// this.refresh();
			const itemInfo = await WSP.fetchItemInfo(this.reg.env.wsp, this, SRC.srcRef(longDesc));
			//A revoir affichage "propre" de N msgs avec type ?
			this._label = ""; //reset ici pour raceCond, si 2 fetchItemInfo en //
			this._details = "";
			if (itemInfo.cPbs) for (const cPb of itemInfo.cPbs) {
				if (this.matchError(cPb)) {
					if (this._label) this._label += "\n" + cPb.msg;
					else this._label = cPb.msg;
					if (cPb.details) {
						if (this._details) this._details += "\n" + cPb.details;
						else this._details = cPb.details;
					}
				}
			}
		}
		this.refresh();
	}

	protected matchError(pb: JItemSsError) {
		if (!this.errors) return true;
		for (const rule of this.errors) {
			if (rule.code.test(pb.code)) return true;
		}
		return false;
	}

	protected _refresh() {
		if (this._label) {
			const longDesc = this.reg.env.longDesc;
			if (longDesc.itSt === EItStatus.warnings) DOM.setAttr(this, "level", "warning");
			else DOM.setAttr(this, "level", "error");
			if (this.details)
				DOM.setAttr(this, "title", this.details)
			this.hidden = false;
			super._refresh();
		} else {
			this.hidden = true;
		}
	}
}

REG.reg.registerSkin("wsp-item-msg-ss", 1, /* language=CSS */ `
	:host {
		text-align: center;
		margin: .3em;
		max-height: 4em;
		display: flex;
		flex-direction: column;
	}

	:host([level=error]) {
		color: var(--error-color);
	}

	:host([level=warning]) {
		color: var(--warning-color);
	}

	.label {
		white-space: pre;
		overflow: auto;
	}
`);


customElements.define("wsp-item-msg-ss", ItemMsgSs);
